import styled from 'styled-components'

import { premiumFontCss } from '@root/entities/premium/ui'
import { PremiumPurchaseBoostersBadge } from '@root/features/pair-activity/ui/common/purchase-boosters-badge'
import { useTranslation } from '@root/shared/localization'

import type { PremiumPurchase } from '@root/entities/premium/model'

export const PremiumPurchaseTablePurchaseCell: React.FC<{
  purchase: PremiumPurchase.Purchase
}> = ({ purchase }) => {
  const { t } = useTranslation()

  if (purchase.type === 'boosters') {
    return <PremiumPurchaseBoostersBadge boosters={purchase.boostersAmount} />
  }
  return (
    <PurchaseTypeRoot>
      <PremiumText>{t('common.d-premium')}</PremiumText>
      {purchase.boostersAmount ? (
        <PremiumPurchaseBoostersBadge boosters={purchase.boostersAmount} />
      ) : undefined}
    </PurchaseTypeRoot>
  )
}

const PurchaseTypeRoot = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;
  justify-content: start;

  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
`

const PremiumText = styled.div`
  ${premiumFontCss}
`
